<template>
    <div class="informationPage scrollBar-custom">
        <template v-if="mixinUserInfo.platformType != 1">
            <div class="formTitle">
                <span>保单信息</span>
            </div>
            <Card>
                <div slot="header" class="flex" style="justify-content: space-between;">
                    <span>交强险保单</span>
                    <el-button type="text" size="medium" @click="editCompulsory">更新</el-button>
                </div>
                <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="保单号">
                                <span>{{ info.compulsoryTrafficInsuranceNo || '-' }}</span>
                            </el-form-item>
                            <el-form-item label="保单起始日期">
                                <span>{{ info.compulsoryTrafficInsuranceStart | filterTime('YYYY-MM-DD') }}</span>
                            </el-form-item>
                            <el-form-item label="保单截止日期">
                                <span>{{ info.compulsoryTrafficInsuranceEnd | filterTime('YYYY-MM-DD') }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="保单照片">
                                <el-image :src="mixinQiniuImg(info.compulsoryTrafficInsurance)"
                                    style="width: 200px; height: 135px;" fit="cover"
                                    :preview-src-list="[mixinQiniuImg(info.compulsoryTrafficInsurance)]">
                                    <div slot="error" class="image-slot">
                                        <span>-</span>
                                    </div>
                                </el-image>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>
            <Card style="margin-top: 20px;">
                <div slot="header" class="flex" style="justify-content: space-between;">
                    <span>商业险保单</span>
                    <el-button type="text" size="medium" @click="editCommercial">更新</el-button>
                </div>
                <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="保单号">
                                <span>{{ info.commercialInsuranceNo || '-' }}</span>
                            </el-form-item>
                            <el-form-item label="保单起始日期">
                                <span>{{ info.commercialInsuranceStart | filterTime('YYYY-MM-DD') }}</span>
                            </el-form-item>
                            <el-form-item label="保单截止日期">
                                <span>{{ info.commercialInsuranceEnd | filterTime('YYYY-MM-DD') }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="保单照片">
                                <el-image :src="mixinQiniuImg(info.commercialInsurance)"
                                    style="width: 200px; height: 135px;" fit="cover"
                                    :preview-src-list="[mixinQiniuImg(info.commercialInsurance)]">
                                    <div slot="error" class="image-slot">
                                        <span>-</span>
                                    </div>
                                </el-image>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>
        </template>

        <div class="dz-page" v-else>
            <el-descriptions :column="2" label-position="left" label-width="120px" size="medium" border>
                <el-descriptions-item label="保单号">
                    <span @dblclick="$utils.dblclickCopy">{{ info.compulsoryTrafficInsuranceNo || '-' }}</span>
                    <el-button type="text" size="medium" @click="editCompulsory" style="margin-left: 8px;">
                        编辑
                    </el-button>
                </el-descriptions-item>
                <el-descriptions-item label="保单类型">交强险保单</el-descriptions-item>
                <el-descriptions-item label="保单起始日期">{{ info.compulsoryTrafficInsuranceStart | filterTime('YYYY-MM-DD') }}</el-descriptions-item>
                <el-descriptions-item label="保单截止日期">{{ info.compulsoryTrafficInsuranceEnd | filterTime('YYYY-MM-DD') }}</el-descriptions-item>
                <el-descriptions-item label="保单照片">
                    <el-image v-if="info.compulsoryTrafficInsurance" :src="mixinQiniuImg(info.compulsoryTrafficInsurance)" style="width: 200px; height: 135px;" fit="cover"
                        :preview-src-list="[mixinQiniuImg(info.compulsoryTrafficInsurance)]">
                    </el-image>
                    <span v-else>-</span>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions :column="2" label-position="left" label-width="120px" size="medium" border style="margin-top: 16px;">
                <el-descriptions-item label="保单号">
                    <span @dblclick="$utils.dblclickCopy">{{ info.commercialInsuranceNo || '-' }}</span>
                    <el-button type="text" size="medium" @click="editCommercial" style="margin-left: 8px;">
                        编辑
                    </el-button>
                </el-descriptions-item>
                <el-descriptions-item label="保单类型">商业险保单</el-descriptions-item>
                <el-descriptions-item label="保单起始日期">{{ info.commercialInsuranceStart | filterTime('YYYY-MM-DD') }}</el-descriptions-item>
                <el-descriptions-item label="保单截止日期">{{ info.commercialInsuranceEnd | filterTime('YYYY-MM-DD') }}</el-descriptions-item>
                <el-descriptions-item label="保单照片">
                    <el-image v-if="info.commercialInsurance" :src="mixinQiniuImg(info.commercialInsurance)" style="width: 200px; height: 135px;" fit="cover"
                        :preview-src-list="[mixinQiniuImg(info.commercialInsurance)]">
                    </el-image>
                    <span v-else>-</span>
                </el-descriptions-item>
            </el-descriptions>
        </div>

        <compulsoryDialog :visible.sync="compulsoryDialogVisible" :info="info" :loading="loading"
            @submit="handleCompulsorySubmit"></compulsoryDialog>
        <commercialDialog :visible.sync="commercialDialogVisible" :info="info" :loading="loading"
            @submit="handleCommercialSubmit"></commercialDialog>
    </div>
</template>

<script>
import compulsoryDialog from './compulsoryDialog.vue'
import commercialDialog from './commercialDialog.vue'

export default {
    components: {
        compulsoryDialog,
        commercialDialog
    },
    data() {
        return {
            compulsoryDialogVisible: false,
            commercialDialogVisible: false,
            loading: false
        }
    },
    props: {
        info: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        editCompulsory() {
            this.compulsoryDialogVisible = true
        },
        editCommercial() {
            this.commercialDialogVisible = true
        },
        async handleCompulsorySubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/vehicle/insurance";
            let params = {
                id: this.info.id,
                ...formData,
                compulsoryTrafficInsuranceStart: new Date(formData.compulsoryTrafficInsuranceStart).setHours(0, 0, 0, 0) / 1000,
                compulsoryTrafficInsuranceEnd: new Date(formData.compulsoryTrafficInsuranceEnd).setHours(0, 0, 0, 0) / 1000,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.compulsoryDialogVisible = false
            }
            this.loading = false
        },
        async handleCommercialSubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/vehicle/insurance";
            let params = {
                id: this.info.id,
                commercialInsurance: formData.commercialInsurance,
                commercialInsuranceNo: formData.commercialInsuranceNo,
                commercialInsuranceStart: new Date(formData.commercialInsuranceStart).setHours(0, 0, 0, 0) / 1000,
                commercialInsuranceEnd: new Date(formData.commercialInsuranceEnd).setHours(0, 0, 0, 0) / 1000,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.commercialDialogVisible = false
            }
            this.loading = false
        },
    }
}
</script>

<style lang="less" scoped>
.dz-page {
    height: 100%;
    :deep(.el-descriptions) {
        border-radius: 8px;
        position: relative;
        overflow: hidden;
    }
    :deep(.el-descriptions)::after {
        content: '';
        pointer-events: none;
        position: absolute;
        inset: 0;
        border-radius: 8px;
        border: 1px solid #EBEEF5;
        z-index: 1;
    }
    :deep(.el-descriptions-row) {
        display: flex;
    }

    :deep(.el-descriptions-item__cell) {
        border-top: 0;
        border-left: 0;
    }

    :deep(.el-descriptions-item__label.is-bordered-label) {
        width: 150px;
        flex-shrink: 0;
        background-color: #FBFBFB;
    }

    :deep(.el-descriptions-item__content) {
        flex: 1;
    }
}
</style>